<div class="flex justify-between px-6 pt-4">
    <p class="text-[1.125rem] text-[#0A0A0A] font-bold">
        {{ data?.isEdit ? 'Edit' : 'Create' }} {{ data?.isGroup ? 'Group' : '' }} Post
    </p>
    <img
        src="/assets/images/shared/cross-black-icon.svg"
        alt="Close"
        class="h-6 w-6 cursor-pointer"
        (click)="onCancel()" />
</div>

<mat-dialog-content class="space-y-1">
    <form class="space-y-4" [formGroup]="postForm">
        <!-- Content -->
        <textarea
            formControlName="content"
            placeholder="Share your thoughts, prayer, or testimony...."
            rows="9"
            class="w-full bg-transparent focus:outline-none resize-none"></textarea>

        <!-- Selected Hashtags -->
        @if (appliedTags().length > 0) {
            <div class="flex flex-wrap gap-2 mt-2">
                @for (tag of appliedTags(); track tag) {
                    <div
                        class="flex items-center space-x-1 bg-[#f0f4ff] text-[#4F66FF] rounded-full px-3 py-1 text-sm font-medium">
                        <p>#{{ tag }}</p>
                        <button type="button" (click)="removeTagByName(tag)">
                            <p class="font-bold">x</p>
                        </button>
                    </div>
                }
            </div>
        }

        <!-- Attachments -->
        @if (postImageUrl || selectedBibleVerses().length || urlPreview()) {
            <p class="text-[0.875rem] text-[#0A0A0A] font-medium">Attachments</p>
        }
        @if (selectedBibleVerses().length) {
            <!-- Preview Selected Verses -->
            @if (selectedBibleVerses().length > 0) {
                <div class="pb-4 px-4 border-b border-[#E7EAF0]">
                    <div class="relative px-4 border-l-4 border-[#4F66FF]">
                        <p class="text-[#4F66FF] font-medium text-[0.75rem] mb-2">
                            {{ getVerseReference(selectedBibleVerses()) }}
                        </p>
                        <button
                            type="button"
                            class="absolute top-1 right-1 w-5 h-5 flex items-center justify-center bg-black rounded-full"
                            (click)="removeBibleVerse()">
                            <img src="/assets/images/shared/x-white-icon.svg" alt="Close" class="h-4 w-auto" />
                        </button>
                        @for (verse of selectedBibleVerses(); track verse.id) {
                            <p class="text-[#717182] text-sm">
                                {{ verse.verse }}
                            </p>
                        }
                    </div>
                </div>
            }
        }
        @if (urlPreview() && urlPreview()!.images.length) {
            @let preview = urlPreview()!;
            <a target="_blank" class="block border rounded-lg overflow-hidden shadow-lg" [href]="preview.url">
                <img alt="Thumbnail" class="w-full h-auto object-cover" [src]="preview.images[0]" />

                <div class="p-2">
                    <div class="flex items-center gap-2">
                        @if (preview.favicons.length) {
                            <img alt="Icon" class="w-6 h-6 object-cover" [src]="preview.favicons[0]" />
                        }
                        <p class="text-[0.7rem] text-[#475569]">{{ preview.siteName }}</p>
                    </div>
                    <p class="text-[0.85rem] font-bold text-[#0F172A]">{{ preview.title }}</p>
                    <p class="text-[0.7rem] text-[#475569] line-clamp-3">{{ preview.description }}</p>
                </div>
            </a>
        }
        @if (postImageUrl) {
            <div class="relative mt-4 inline-block">
                <img alt="Preview" class="rounded-lg block max-w-full max-h-[320px] h-auto" [src]="postImageUrl" />
                <button
                    type="button"
                    class="absolute top-1 right-1 w-5 h-5 flex items-center justify-center bg-black rounded-full"
                    (click)="removePostImage()">
                    <img src="/assets/images/shared/x-white-icon.svg" alt="Close" class="h-4 w-auto" />
                </button>
            </div>
        }

        <!-- Quote -->
        @if (data?.isQuote && data?.quote) {
            <div class="p-6 rounded-2xl space-y-2 bg-[#e0efff]">
                <!-- Author Info -->
                <div class="flex space-x-4">
                    @if (data.quote.author.photo !== ' ' && data.quote.author.photo) {
                        <img
                            class="h-12 w-12 rounded-full object-cover border border-[#e7eaf0]"
                            [alt]="data.quote.author.name"
                            [src]="data.quote.author.photo" />
                    } @else {
                        <div
                            class="h-12 w-12 rounded-full border border-[#e7eaf0] bg-white text-[#4F66FF] flex items-center justify-center font-bold text-[1.2rem]">
                            {{ data.quote.author.name.charAt(0) | uppercase }}
                        </div>
                    }
                    <div class="flex flex-col">
                        <p class="text-[#0A0A0A]">
                            {{
                                data.quote.privacy === PrivacyTypeEnum.Anonymous
                                    ? data.quote.anonymousName
                                    : data.quote.author.name
                            }}
                        </p>
                        <div class="flex items-center space-x-2">
                            <p class="text-[0.875rem] text-[#717182]">
                                {{ timeAgo(data.quote.createdAt) }}
                            </p>
                            <img
                                alt="Privacy"
                                class="h-3 w-3"
                                [src]="
                                    data.quote.privacy === 'public'
                                        ? '/assets/images/post/public-icon.svg'
                                        : data.quote.privacy === 'anonymous'
                                          ? '/assets/images/post/anonymous-icon.svg'
                                          : '/assets/images/post/friends-icon.svg'
                                " />
                        </div>
                    </div>
                </div>

                <!-- Post Type  -->
                <div
                    class="w-fit flex space-x-1 text-[0.875rem] rounded-full py-1 px-2 capitalize"
                    [ngClass]="
                        data.quote.type === PostTypeEnum.Prayer
                            ? 'bg-[#4F66FF0D] text-[#4F66FF]'
                            : data.quote.type === PostTypeEnum.Testimony
                              ? 'bg-[#ECFDF5] text-[#059669]'
                              : data.quote.type === PostTypeEnum.Post
                                ? 'bg-[#FFF1F2] text-[#E11D48]'
                                : 'bg-white border'
                    ">
                    @if (
                        data.quote.type === PostTypeEnum.Prayer ||
                        data.quote.type === PostTypeEnum.Testimony ||
                        data.quote.type === PostTypeEnum.Post
                    ) {
                        <img
                            class="h-4 w-auto"
                            alt="PostType"
                            [src]="
                                data.quote.type === PostTypeEnum.Prayer
                                    ? '/assets/images/post/prayer-icon.svg'
                                    : data.quote.type === PostTypeEnum.Testimony
                                      ? '/assets/images/post/testimony-icon.svg'
                                      : '/assets/images/post/encouragement-icon.svg'
                            " />
                    }
                    <p>
                        {{ getPostTypeLabel(data.quote.type) }}
                    </p>
                </div>

                <!-- Hashtags -->
                <div class="flex flex-wrap gap-2">
                    @for (tag of data.quote.cats; track tag) {
                        <div class="w-fit truncate whitespace-nowrap text-[0.875rem] text-[#4F66FF] capitalize">
                            <p>#{{ tag }}</p>
                        </div>
                    }
                </div>

                <!-- Content -->
                <div class="mt-4 text-[#0A0A0A] break-words" [innerHTML]="coloredQuoteContent"></div>

                <!-- Bible Verses -->
                @if (data.quote.verses && data.quote.verses.length) {
                    <div class="py-1 px-4 border-l-4 border-[#4F66FF]">
                        <p class="text-[#4F66FF] font-medium text-[0.75rem] mb-2">
                            {{ getVerseReference(data.quote.verses) }}
                        </p>
                        @for (verse of data.quote.verses; track verse.id) {
                            <p class="text-[#717182] text-sm">
                                {{ verse.verse }}
                            </p>
                        }
                    </div>
                }
                <!-- Thumbnail Previews -->
                @if (data.quote.url && data.quoteUrlPreview() && data.quoteUrlPreview()!.images.length) {
                    @let preview = data.quoteUrlPreview()!;
                    <a
                        target="_blank"
                        class="bg-white block border rounded-lg overflow-hidden shadow-lg"
                        [href]="preview.url">
                        <img alt="Thumbnail" class="w-full h-auto object-cover" [src]="preview.images[0]" />

                        <div class="p-2">
                            <div class="flex items-center gap-2">
                                @if (preview.favicons.length) {
                                    <img alt="Icon" class="w-6 h-6 object-cover" [src]="preview.favicons[0]" />
                                }
                                <p class="text-[0.7rem] text-[#475569]">{{ preview.siteName }}</p>
                            </div>
                            <p class="text-[0.85rem] font-bold text-[#0F172A]">{{ preview.title }}</p>
                            <p class="text-[0.7rem] text-[#475569] line-clamp-3">{{ preview.description }}</p>
                        </div>
                    </a>
                }

                <!-- Image -->
                @if (data.quote.photo) {
                    <img alt="Image" class="rounded-lg block max-w-full h-auto" [src]="data.quote.photo" />
                }
            </div>
        }
    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <!-- Actions -->
    <div class="flex justify-between items-end w-full">
        <!-- Left side actions -->
        <div class="flex flex-wrap sm:flex-nowrap sm:gap-6 gap-3 items-center">
            <div class="flex gap-6 items-center flex-shrink-0">
                <!-- Upload Image -->
                <input #fileInput type="file" accept="image/*" class="hidden" (change)="onFileSelected($event)" />
                @if (!data?.isQuote) {
                    <button type="button" class="flex-shrink-0" (click)="fileInput.click()">
                        <img src="/assets/images/shared/upload-image-icon.svg" alt="UploadImage" class="h-5 w-auto" />
                    </button>
                }

                <!-- Bible Verse -->
                @if (!data?.isQuote) {
                    <button type="button" class="flex-shrink-0" (click)="openBibleVersePopup()">
                        <img src="/assets/images/shared/bible-icon.svg" alt="Bible" class="h-5 w-auto" />
                    </button>
                }

                <!-- Hashtag -->
                <button
                    #hashtagsTrigger="matMenuTrigger"
                    type="button"
                    class="flex-shrink-0"
                    [matMenuTriggerFor]="dropdownHashtagsTypeMenu">
                    <img src="/assets/images/shared/hashtag-icon.svg" alt="Hashtag" class="h-4 w-auto" />
                </button>
            </div>

            <!-- Post + Privacy -->
            @if (!data?.isQuote && !data?.isEdit) {
                <div class="flex gap-3 sm:gap-6 mt-3 sm:mt-0 w-full sm:w-auto justify-start sm:justify-normal">
                    <!-- Post Type Dropdown -->
                    <button
                        type="button"
                        class="flex items-center space-x-2 flex-shrink-0"
                        [matMenuTriggerFor]="dropdownPostTypeMenu">
                        <img
                            alt="PostType"
                            class="w-auto h-4 flex-shrink-0"
                            [src]="postTypeIconConfig[selectedType]?.icon" />
                        <p class="text-[#0A0A0A] whitespace-nowrap text-[0.875rem] flex-1 text-left">
                            {{ getPostTypeLabel(selectedType) }}
                        </p>
                        <img
                            alt="DownArrow"
                            class="h-3 w-3 flex-shrink-0"
                            src="/assets/images/shared/down-arrow-grey-icon.svg" />
                    </button>

                    @if (!data?.isGroup) {
                        <!-- Privacy Type Dropdown -->
                        <button
                            type="button"
                            class="flex items-center space-x-2 flex-shrink-0"
                            [matMenuTriggerFor]="dropdownPrivacyTypeMenu">
                            <img
                                alt="PrivacyType"
                                class="w-auto h-4 flex-shrink-0"
                                [src]="
                                    selectedPrivacy === PrivacyTypeEnum.Public
                                        ? '/assets/images/post/public-icon.svg'
                                        : selectedPrivacy === PrivacyTypeEnum.Follower
                                          ? '/assets/images/post/friends-icon.svg'
                                          : '/assets/images/post/anonymous-icon.svg'
                                " />
                            <p class="text-[#4b4848] whitespace-nowrap text-[0.875rem] flex-1 text-left">
                                {{ getPrivacyTypeLabel(selectedPrivacy) }}
                            </p>
                            <img
                                alt="DownArrow"
                                class="h-3 w-3 flex-shrink-0"
                                src="/assets/images/shared/down-arrow-grey-icon.svg" />
                        </button>
                    }
                </div>
            }
        </div>

        <!-- Submit -->
        <button
            type="button"
            class="border-button sm:p-3 p-2 rounded-full flex-shrink-0 mt-3 sm:mt-0"
            [disabled]="postForm.invalid"
            (click)="submit()">
            <img src="/assets/images/shared/up-arrow-icon.png" alt="Up" class="h-5 w-auto" />
        </button>
    </div>
</mat-dialog-actions>

<!-- Post Type Menu -->
<mat-menu #dropdownPostTypeMenu="matMenu">
    @if (!data?.isGroup) {
        <div
            class="flex items-center gap-2 p-2 cursor-pointer hover:bg-[#f5f6f8]"
            (click)="selectPostType(PostTypeEnum.Prayer)">
            <img class="w-auto h-4" alt="Prayer" src="/assets/images/post/prayer-icon.svg" />
            <p class="text-[0.875rem] text-[#0A0A0A]">{{ getPostTypeLabel(PostTypeEnum.Prayer) }}</p>
        </div>
        <div
            class="flex items-center gap-2 p-2 cursor-pointer hover:bg-[#f5f6f8]"
            (click)="selectPostType(PostTypeEnum.Post)">
            <img class="w-auto h-4" alt="Encouragement" src="/assets/images/post/encouragement-icon.svg" />
            <p class="text-[0.875rem] text-[#0A0A0A]">{{ getPostTypeLabel(PostTypeEnum.Post) }}</p>
        </div>
        <div
            class="flex items-center gap-2 p-2 cursor-pointer hover:bg-[#f5f6f8]"
            (click)="selectPostType(PostTypeEnum.Testimony)">
            <img class="w-auto h-4" alt="Testimony" src="/assets/images/post/testimony-icon.svg" />
            <p class="text-[0.875rem] text-[#0A0A0A]">{{ getPostTypeLabel(PostTypeEnum.Testimony) }}</p>
        </div>
    } @else if (data?.isGroup) {
        <div
            class="flex items-center gap-2 p-2 cursor-pointer hover:bg-[#f5f6f8]"
            (click)="selectPostType(PostTypeEnum.Group)">
            <img class="w-auto h-4" alt="Group" src="/assets/images/shared/group-icon.svg" />
            <p class="text-[0.875rem] text-[#0A0A0A]">{{ getPostTypeLabel(PostTypeEnum.Group) }}</p>
        </div>
        <div
            class="flex items-center gap-2 p-2 cursor-pointer hover:bg-[#f5f6f8]"
            (click)="selectPostType(PostTypeEnum.Announcement)">
            <img class="w-auto h-4" alt="Announcement" src="/assets/images/post/admin-icon.svg" />
            <p class="text-[0.875rem] text-[#0A0A0A]">{{ getPostTypeLabel(PostTypeEnum.Announcement) }}</p>
        </div>
    }
</mat-menu>

<!-- Privacy Type Menu -->
<mat-menu #dropdownPrivacyTypeMenu="matMenu">
    <div
        class="flex items-center gap-2 p-2 cursor-pointer hover:bg-[#f5f6f8]"
        (click)="selectPrivacyType(PrivacyTypeEnum.Public)">
        <img class="w-auto h-4" alt="Public" src="/assets/images/post/public-icon.svg" />
        <p class="text-[0.875rem] text-[#0A0A0A]">{{ getPrivacyTypeLabel(PrivacyTypeEnum.Public) }}</p>
    </div>

    <div
        class="flex items-center gap-2 p-2 cursor-pointer hover:bg-[#f5f6f8]"
        (click)="selectPrivacyType(PrivacyTypeEnum.Follower)">
        <img class="w-auto h-4" alt="Encouragement" src="/assets/images/post/friends-icon.svg" />
        <p class="text-[0.875rem] text-[#0A0A0A]">{{ getPrivacyTypeLabel(PrivacyTypeEnum.Follower) }}</p>
    </div>

    <div
        class="flex items-center gap-2 p-2 cursor-pointer hover:bg-[#f5f6f8]"
        (click)="selectPrivacyType(PrivacyTypeEnum.Anonymous)">
        <img class="w-auto h-4" alt="Testimony" src="/assets/images/post/anonymous-icon.svg" />
        <p class="text-[0.875rem] text-[#0A0A0A]">{{ getPrivacyTypeLabel(PrivacyTypeEnum.Anonymous) }}</p>
    </div>
</mat-menu>

<!-- Hashtags Menu -->
<mat-menu #dropdownHashtagsTypeMenu="matMenu">
    <div (click)="$event.stopPropagation()">
        <div class="flex justify-between items-center p-2 border-b border-[#E7EAF0]">
            <p class="text-[0.875rem] text-[#0A0A0A] font-semibold">Hashtags</p>
            <button type="button" class="border-button" (click)="applyTags(); hashtagsTrigger.closeMenu()">
                Apply
            </button>
        </div>

        <div class="flex flex-wrap gap-2 mt-3 px-2">
            @for (tag of hashtagsMap() | keyvalue; track tag) {
                <button
                    type="button"
                    class="px-3 py-1 rounded-full border text-[0.8rem] font-medium transition duration-150"
                    [ngClass]="tag.value.isSelected ? 'active-tag' : 'inactive-tag'"
                    (click)="toggleTag(tag.value.id); $event.stopPropagation()">
                    #{{ tag.value.name }}
                </button>
            }
        </div>
    </div>
</mat-menu>
